// sessionStorage, not router state: unlocking an org redirects the whole browser to the
// identity provider and back, which wipes anything held in memory.
//
// The SAML callback URL carries only the code and the user id, so the org the user actually
// clicked cannot be recovered on the way back. That matters for a method shared across
// organizations (`linkedOrganizationIds`): without this, activation falls back to the
// method's owner org and the user lands somewhere they did not pick.

const STORAGE_KEY = 'pendingSsoUnlockOrganizationId';

const isObjectId = value => typeof value === 'string' && /^[a-f\d]{24}$/i.test(value);

export const setPendingSsoUnlock = organizationId => {
  if (!isObjectId(organizationId)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, organizationId);
  } catch {
    // sessionStorage may be unavailable (private mode); activation then falls back to the
    // method's owner org, which is the pre-existing behaviour.
  }
};

// Read-and-clear, so a stale id can never leak into a later, unrelated round-trip.
export const consumePendingSsoUnlock = () => {
  try {
    const organizationId = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return isObjectId(organizationId) ? organizationId : null;
  } catch {
    return null;
  }
};
